/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next';
import { CSVLink } from 'react-csv';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import { Table, Typography } from 'antd';
import 'antd/dist/antd.min.css';

import * as types from 'reducer/actionTypes';
import { isEmpty } from 'script/common';

const { Text } = Typography;
class Stats extends React.Component {
	//조회
	onClickSearch = (e) => {
		const optionPeriod = document.getElementById('optionPeriod').value;
		const optionItem= document.getElementById('optionItem').value;

		const dateFormat = (optionPeriod === '0') ? 'YYYY-MM-DD' : 'YYYY-MM'
		const startDate = moment(document.getElementById('startDate').value).format(dateFormat)
		const endDate = moment(document.getElementById('endDate').value).format(dateFormat)
		
		const msDiff = new Date(endDate).getTime() - new Date(startDate).getTime();
		
		if (msDiff < 0) {
			this.props.setErrorLabel('날짜를 다시 확인하세요.');
			return;
		} else {
			// initialState
			this.props.setCondition(null).then(() => {
				const data = {
					...this.props.stats.condition,
					optionPeriod: optionPeriod,
					optionItem: optionItem,
					startDate: startDate,
					endDate: endDate
				};

				this.props.fetchStatsSummaryInfo(data)
			})
		}
	}

	//페이징, 컬럼 정렬 버튼
	onChangePage = (page, filters, sorter) => {
		let condition = {
			...this.props.stats.condition,
			pagination: {
				...this.props.stats.condition.pagination,
				current: page.current,
				pagingStart: (page.current-1) * page.pageSize
			},
			orderby : isEmpty(sorter.order) ? this.props.stats.condition.orderby : {columnKey: sorter.columnKey, order: sorter.order.replace('end','')}
		}

		this.props.fetchStatsSummaryInfo(condition)
	}

	//CSV 다운로드 (마지막 조회결과 다운로드)
	onClickCsv = (csvLink) => {
		if (isEmpty(this.props.stats.summaryInfo)) {
			this.props.setErrorLabel('No Download Data')
			return null
		} else {
			this.props.fetchStatsSummaryCsv(this.props.stats.condition,csvLink)
		}
	}

	onChangeOptionPeriod = (e) => {
		this.props.setOptionPeriod(Number(e.target.value))
		this.onChangeStartDate(new Date())
		this.onChangeEndDate(new Date())
	}

	onChangeStartDate = (value) => {
		if (value !== null){
			const date = moment(value).format('YYYY-MM-DD')
			this.props.setStartDate(date)
		}
	}

	onChangeEndDate = (value) => {
		if (value !== null){
			const date = moment(value).format('YYYY-MM-DD')
			this.props.setEndDate(date);
		}
	}

	onDateKeyPress = (e) => {
		var len = e.target.value.length;
		if( len === 4 ) e.target.value += '-';

		if (this.props.stats.search.optionPeriod===0) {
			if ( len === 7 ) e.target.value += '-';
		}
	}

	render(){
		const {t, stats} = this.props;

		const optionPeriodList=[
			{label:'stats.option.daily', value:0},
			{label:'stats.option.monthly', value:1},
		]

		const optionItemList=[
			{label:'stats.option.uv', value:0},
			{label:'stats.option.pv', value:1},
			{label:'stats.option.co', value:2}
		]

		let isSorter = isEmpty(this.props.stats.summaryInfo) ? false : true
		const selectedPeriod = optionPeriodList.find(item => item.value === Number(stats.condition?.optionPeriod)) || optionPeriodList[0];

		let columns = [
			{
				title: t('stats.content.date'),
				dataIndex: 'date',
				key: 'date',
				sorter: isSorter
			},
			{
				title: t('office.write'),
				dataIndex: 'write',
				key: 'write',
				sorter: isSorter
			},
			{
				title: t('office.calc'),
				dataIndex: 'calc',
				key: 'calc',
				sorter: isSorter
			},
			{
				title: t('office.show'),
				dataIndex: 'show',
				key: 'show',
				sorter: isSorter
			},
			{
				title: t(selectedPeriod.label),
				dataIndex: 'total',
				key: 'total'
			}
		];

		// 요일 반환
		const getDayName = (date) => { return date.toLocaleDateString('en-US',{weekday:'long'}) }
		// 날짜 비교시 년 월 일까지만 비교
		const createDate = (date) => { return new Date(new Date(date.getFullYear(),date.getMonth(),date.getDate(),0,0,0)) }

		const summaryData = isEmpty(this.props.stats.summaryTotal) ? null : this.props.stats.summaryTotal[0]

		return(
			<>
				<h2>{t('stats.main.title')}</h2>
				<div className="content_box">
					<div style={{margin:"10px"}}>
						{/* Control */}
						<div className='stl_bar'>
							<select className='item_dropdown' id='optionPeriod' defaultValue='0' onChange={this.onChangeOptionPeriod}>
								{optionPeriodList.map((data) => {
									return(<option value={data.value} key={data.value}>{t(data.label)}</option>)
								})}
							</select>
							<select className='item_dropdown' id='optionItem' defaultValue='0'>
								{optionItemList.map((data) => {
									return(<option value={data.value} key={data.value}>{t(data.label)}</option>)
								})}
							</select>
							<DatePicker
								className='item_input'
								id='startDate'
								selected={new Date(this.props.stats.search.startDate)}
								onChange={this.onChangeStartDate}
								showMonthYearPicker={(this.props.stats.search.optionPeriod===0) ? false : true}
								dateFormat={(this.props.stats.search.optionPeriod===0) ? 'yyyy-MM-dd' : 'yyyy-MM'}
								dayClassName={date => getDayName(createDate(date))}
								customInput={<input type='text' onKeyPress={this.onDateKeyPress}
												maxLength={(this.props.stats.search.optionPeriod===0) ? '10' : '7'}/>}
							/>
							<span style={{margin:'06px'}}>~</span>
							<DatePicker
								className='item_input'
								id='endDate'
								selected={new Date(this.props.stats.search.endDate)}
								onChange={this.onChangeEndDate}
								showMonthYearPicker={(this.props.stats.search.optionPeriod===0) ? false : true}
								dateFormat={(this.props.stats.search.optionPeriod===0) ? 'yyyy-MM-dd' : 'yyyy-MM'}
								dayClassName={date => getDayName(createDate(date))}
								customInput={<input type='text' onKeyPress={this.onDateKeyPress}
												maxLength={(this.props.stats.search.optionPeriod===0) ? '10' : '7'}/>}
							/>
							{isEmpty(this.props.stats.errorLabel) ? null : <div className='error' style={{display:'block', marginLeft:'4px'}}>{this.props.stats.errorLabel}</div>}
							<button className='btn_text_b icon_btn' style={{marginLeft:'auto'}} onClick={this.onClickSearch}>{t('stats.button.search')}</button>
							<button className='btn_text_b btn_text_w icon_btn' onClick={() => this.onClickCsv(this.csvLink)}>
								<span className='icon_down'/>{t('stats.button.csv')}
							</button>
							<CSVLink data={this.props.stats.summaryCsv} filename={'weboffice_stats.csv'} ref={(r) => this.csvLink = r} target='_blank' style={{display:'none'}}/>
						</div>
						{/* Table */}
						<div>
							<Table
								scroll={{ y: document.documentElement.clientHeight * 0.45}}
								columns={columns}
								// pagination={this.props.stats.condition.pagination}
								dataSource={this.props.stats.summaryInfo.map((data,i) => {
									return {
										...data
										, key: i
									}
								})}
								loading={this.props.apiCalling}
								onChange = {this.onChangePage}
								sticky
								summary={() =>
									(
										<Table.Summary fixed='top'>
											<Table.Summary.Row>
												<Table.Summary.Cell><Text>{summaryData === null ? null : summaryData.date}</Text></Table.Summary.Cell>
												<Table.Summary.Cell><Text>{summaryData === null ? null : summaryData.write}</Text></Table.Summary.Cell>
												<Table.Summary.Cell><Text>{summaryData === null ? null : summaryData.calc}</Text></Table.Summary.Cell>
												<Table.Summary.Cell><Text>{summaryData === null ? null : summaryData.show}</Text></Table.Summary.Cell>
												<Table.Summary.Cell><Text>{summaryData === null ? null : summaryData.total}</Text></Table.Summary.Cell>
											</Table.Summary.Row>
										</Table.Summary>
									)
								}
							/>
						</div>
					</div>
				</div>
			</>
		)
	}
}

// state를 해당 컴포넌트의 props로 연결
const mapStateToProps = (reducers) => {
	return{
		stats: reducers.stats,
		apiCalling: reducers.apiCalling.apiCalling,
	}
}

// 컴포넌트의 함수형 poprs를 실행했을때, 지정한 action을 dispatch 하도록 설정
const mapDispatchToProps = (dispatch) => {
	return {
		setErrorLabel: (value) => {dispatch({type: types.SET_STATS_ERRORLABEL, errorLabel:value})},
		setOptionPeriod: (value) => {dispatch({type: types.SET_STATS_OPTION_PERIOD, value:value})},
		setStartDate: (date) => {dispatch({type: types.SET_STATS_STARTDATE, startDate:date})},
		setEndDate: (date) => {dispatch({type: types.SET_STATS_ENDTDATE, endDate:date})},
		setCondition: async(value) => {dispatch({type: types.SET_STATS_CONDITION, condition:value})},
		fetchStatsSummaryInfo: (value) => {dispatch({type: types.FETCH_GET_STATS_SUMMARY_INFO_REQUEST, condition:value})},
		fetchStatsSummaryCsv: (value,event) => {dispatch({type: types.FETCH_GET_STATS_SUMMARY_CSV_REQUEST, value:value, event:event})},
	}
}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Stats))